import { createPhysicsWorld } from '../Builder/PhysicsWorldBuilder';
import * as RAPIER from '@dimforge/rapier3d-compat';

let RapierInstance = null;
let PhysicsWorldInstance = null;

// ça marche sans faire ça une fois je ne sais pas pourquoi
(async () => {
    await RAPIER.init();
})();

export const Rapier = async () => {

    if (!RapierInstance) {
        await RAPIER.init();
        RapierInstance = RAPIER
    }
    return RapierInstance;
}

export const PhysicsWorld = async () => {
    if (!PhysicsWorldInstance) {
        PhysicsWorldInstance = await createPhysicsWorld();
    }
    return PhysicsWorldInstance;
}